$(document).on('ready', function () {

    $('.radio.radio_reset-inner').each(function () {
        var $this = $(this);
        var $input = $this.find('.radio__input');
        var $inner = $this.find('.radio__is-checked');

        $input.on('change', function () {
            $this.parent('form').find('.radio.radio_reset-inner').each(function () {
                $(this).find('.radio__is-checked').find('input, textarea, select').each(function () {
                    if ($(this).is('select')) {
                        $(this).val($(this).find("option:first").val());
                    }
                    else {
                        $(this).val('');
                    }
                });
            });
        });
    });

    $('.input_togglable').each(function () {
        var $this = $(this);
        var opts = $this.data();
        var $form = $this.parents('.form');

        $form
        .find("[name=\"" + opts.inputTogglableExpectedId + "\"]")
        .on('change', function () {

            if ($(this).val() === String(opts.inputTogglableExpectedField)) {
                $this.show();
            }
            else {
                $this.hide();
            }
        });
    });

    $('.input-w-plus-minus').each(function() {
        var $root = $(this);
        var $minus = $root.find('.input-w-plus-minus__minus_action');
        var $plus = $root.find('.input-w-plus-minus__plus_action');
        var $input = $root.find('.input-w-plus-minus__input');
        var $setValue = $root.find('.input-w-plus-minus__set-value');

        var minValue = typeof $root.data('min-value') != 'undefined' ? parseFloat($root.data('min-value')) : null;
        var maxValue = typeof $root.data('max-value') != 'undefined' ? parseFloat($root.data('max-value')) : null;
        var step = $root.data('step') ? $root.data('step') : 1;
        var precision = $root.data('precision') ? parseInt($root.data('precision')) : 0;
        var minPositiveValue = typeof $root.data('min-positive-value') != 'undefined' && parseFloat($root.data('min-positive-value')) > 0 ? parseFloat($root.data('min-positive-value')) : null;

        var getValue = function() {
            var currentValue = parseFloat($input.val());
            if (_.isNaN(currentValue)) {
                currentValue = 0;
            }

            return currentValue;
        };

        $input.on('change', function(e, action) {
            var newValue = getValue();
            if (!_.isNull(minValue) && newValue < minValue) {
                newValue = minValue;
            } else if (!_.isNull(maxValue) && newValue > maxValue) {
                newValue = maxValue;
            } else if (!_.isNull(minPositiveValue) && newValue > 0 && newValue < minPositiveValue) {
                if (action && action == 'minus') {
                    newValue = 0;
                } else {
                    newValue = minPositiveValue;
                }
            }
            newValue = newValue.toFixed(precision);
            $(this).val(newValue);
            $root.trigger('InputWithPlusMinus::Change', [newValue, action]);
        });

        $minus.on('click', function(e) {
            e.preventDefault();
            var currentValue = getValue();
            var realValue = $input.val();
            var newValue = currentValue - step;
            if (realValue !== '' && !_.isNull(minValue) && newValue < minValue) {
                return;
            }
            $input.val(newValue);
            $input.trigger('change', ['minus']);
        });

        $plus.on('click', function(e) {
            e.preventDefault();
            var currentValue = getValue();
            var realValue = $input.val();
            var newValue = currentValue + step;
            if (realValue !== '' && !_.isNull(maxValue) && newValue > maxValue) {
                return;
            }
            $input.val(newValue);
            $input.trigger('change', ['plus']);
        });

        $setValue.on('click', function(e) {
            e.preventDefault();
            var newValue = $(this).data('value');
            $input.val(newValue);
            $input.trigger('change', ['set']);
        });
    });
});
